<template>
  <button
    type="button"
    :class="handleClass"
    :data-reorder-id="reorderId"
    aria-label="Drag to reorder, or use arrow keys"
    :aria-keyshortcuts="allowOut ? 'ArrowUp ArrowDown ArrowLeft' : 'ArrowUp ArrowDown'"
    @click.stop
    @keydown.up.prevent="$emit('move', 'up')"
    @keydown.down.prevent="$emit('move', 'down')"
    @keydown.left.prevent="onLeft"
  >
    <font-awesome-icon icon="grip-vertical" />
  </button>
</template>

<script>
export default {
  name: 'DragHandle',
  props: {
    handleClass: { type: String, default: 'drag-handle' },
    reorderId: { type: String, default: '' },
    allowOut: { type: Boolean, default: false }
  },
  emits: ['move'],
  methods: {
    onLeft (event) {

      if (!this.allowOut) return

      event.preventDefault()
      this.$emit('move', 'out')
    }
  }
}
</script>
